import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import LeadDialog from "./LeadDialog";
import { NAV, CONTACT, SERVICES } from "../lib/site";
import { Phone, Mail } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative border-t border-white/10 bg-isav-bg2">
      <div className="mx-auto max-w-[1600px] px-6 py-20 md:px-12">
        <div className="grid grid-cols-1 gap-14 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <Logo />
            <p className="mt-8 max-w-md font-serif text-3xl font-300 leading-tight text-white/90">
              Intelligent Living. <span className="italic accent-text">Beautifully Designed.</span>
            </p>
            <div className="mt-8">
              <LeadDialog kind="consultation" variant="accent" testId="footer-book-consultation" />
            </div>
          </div>

          <div className="lg:col-span-2">
            <p className="mb-6 text-[10px] uppercase tracking-[0.25em] text-white/40">Explore</p>
            <ul className="space-y-3">
              {NAV.map((n) => (
                <li key={n.to}>
                  <Link to={n.to} className="text-sm text-white/60 transition-colors hover:text-white">
                    {n.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <p className="mb-6 text-[10px] uppercase tracking-[0.25em] text-white/40">Capabilities</p>
            <ul className="space-y-3">
              {SERVICES.slice(0, 5).map((s) => (
                <li key={s.slug}>
                  <Link to={`/services#${s.slug}`} className="text-sm text-white/60 transition-colors hover:text-white">
                    {s.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <p className="mb-6 text-[10px] uppercase tracking-[0.25em] text-white/40">Contact</p>
            <a href={CONTACT.phoneHref} className="flex items-center gap-3 text-sm text-white/60 transition-colors hover:text-white">
              <Phone className="h-4 w-4" /> {CONTACT.phone}
            </a>
            <a href={`mailto:${CONTACT.email}`} className="mt-3 flex items-center gap-3 text-sm text-white/60 transition-colors hover:text-white">
              <Mail className="h-4 w-4" /> {CONTACT.email}
            </a>
            <p className="mt-6 text-[11px] leading-relaxed text-white/40">
              Serving {CONTACT.serviceAreas.join(" · ")}.
            </p>
            <p className="mt-3 font-mono text-[11px] text-white/40">CSLB #{CONTACT.license}</p>
          </div>
        </div>

        <div className="mt-16 accent-line" />
        <div className="mt-6 flex flex-col items-start justify-between gap-3 text-[11px] text-white/35 md:flex-row md:items-center">
          <p>© {new Date().getFullYear()} Integrated Solutions AV. All rights reserved.</p>
          <p className="font-mono uppercase tracking-[0.2em]">Home Automation · Lighting · Home Theater</p>
        </div>
      </div>
    </footer>
  );
}
